import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faStar } from '@fortawesome/free-solid-svg-icons/faStar';
import type { IconProps } from '../../types';

export function StarIcon({ 
  className, 
  size = 24, 
  color,
  'aria-label': ariaLabel = 'Star',
}: IconProps) {
  return (
    <FontAwesomeIcon 
      icon={faStar}
      className={className}
      style={{ 
        width: typeof size === 'number' ? size : undefined,
        height: typeof size === 'number' ? size : undefined,
      }}
      color={color}
      aria-label={ariaLabel}
      role="img"
    />
  );
}
